import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import React, {
  Component,
} from 'react';
import Directives from '../../../Directives/Directives';
import classes from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IInputField,
} from '../formFields';

interface IProps extends IInputField {
  errors: any;
  touched: any;

  onChange(name: string): any;
}

class InputField extends Component<IProps> {
  render() {
    let inputProps = {
    };
    if (this.props.suffix) {
      inputProps = {
        endAdornment: <InputAdornment position="end">{this.props.suffix}</InputAdornment>,
      };
    }

    return (
      <FormControl className={classes.filed}>
        <TextField
          name={this.props.name}
          type={this.props.type}
          value={this.props.value}
          variant="outlined"
          multiline={(!!this.props.multiLine)}
          rowsMax={this.props.rowsMax ? this.props.rowsMax : 1}
          onChange={this.props.onChange(this.props.name)}
          label={this.props.label}
          InputProps={inputProps}
          disabled={this.props.disabled}
        />
        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={classes.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default InputField;
